import { render } from "./AnnouncementOverview.vue?vue&type=template&id=e19d9ef0&scoped=true&ts=true"
import script from "./AnnouncementOverview.vue?vue&type=script&lang=ts"
export * from "./AnnouncementOverview.vue?vue&type=script&lang=ts"

import "./AnnouncementOverview.vue?vue&type=style&index=0&id=e19d9ef0&lang=scss&scoped=true"

import exportComponent from "/data/home/cazaleres/application/cazaleres-owner/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e19d9ef0"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
